__turbopack_context__.v({
  "closeButton": "BlogImageViewer-module-scss-module__izEOSq__closeButton",
  "container": "BlogImageViewer-module-scss-module__izEOSq__container",
  "enter": "BlogImageViewer-module-scss-module__izEOSq__enter",
  "exit": "BlogImageViewer-module-scss-module__izEOSq__exit",
  "fade-in": "BlogImageViewer-module-scss-module__izEOSq__fade-in",
  "fade-out": "BlogImageViewer-module-scss-module__izEOSq__fade-out",
  "fade-out-80": "BlogImageViewer-module-scss-module__izEOSq__fade-out-80",
  "overlay": "BlogImageViewer-module-scss-module__izEOSq__overlay",
  "slide-in-from-bottom": "BlogImageViewer-module-scss-module__izEOSq__slide-in-from-bottom",
  "slide-in-from-left": "BlogImageViewer-module-scss-module__izEOSq__slide-in-from-left",
  "slide-in-from-right": "BlogImageViewer-module-scss-module__izEOSq__slide-in-from-right",
  "slide-in-from-top": "BlogImageViewer-module-scss-module__izEOSq__slide-in-from-top",
  "slide-out-to-bottom": "BlogImageViewer-module-scss-module__izEOSq__slide-out-to-bottom",
  "slide-out-to-left": "BlogImageViewer-module-scss-module__izEOSq__slide-out-to-left",
  "slide-out-to-right": "BlogImageViewer-module-scss-module__izEOSq__slide-out-to-right",
  "slide-out-to-top": "BlogImageViewer-module-scss-module__izEOSq__slide-out-to-top",
  "viewerImage": "BlogImageViewer-module-scss-module__izEOSq__viewerImage",
  "zoom-in": "BlogImageViewer-module-scss-module__izEOSq__zoom-in",
  "zoom-out": "BlogImageViewer-module-scss-module__izEOSq__zoom-out",
  "zoomIndicator": "BlogImageViewer-module-scss-module__izEOSq__zoomIndicator",
});
